export const COLLAPSED_SIZE = 15;
export const COLLAPSE_TRANSITION_TIMEOUT = 350;
export const COLLAPSE_DIRECTION_RIGHT = 'right';
export const SPLIT_DIRECTION_VERTICAL = 'vertical';
export const SPLIT_DIRECTION_HORIZONTAL = 'horizontal';
export const OPERATION_MENU_MIN_SIZE = 300;
export const OPERATION_MENU_MAX_SIZE = 300;
export const INITIAL_SIZE_RATIO_BETWEEN_OPERATION_MENU_AND_NON_OPERATION_MENU = [1, 5];
export const INITIAL_SIZE_RATIO_BETWEEN_CODE_PANEL_AND_EVENT_PANEL = [3, 1];
export const INITIAL_SIZE_RATIO_BETWEEN_CODE_PANEL_AND_PREVIEW_PANEL = [1, 1];
export const RESIZER_BACKGROUND_COLOR = '#0E6FF9';
export const RESIZER_TRANSPARENT_BACKGROUND = 'transparent';
export const RESIZER_HOVER_SIZE = '3px';
// This value should be negative and half of RESIZER_HOVER_SIZE.
export const RESIZER_POSITION_OFFSET = '-1.5px';
export const GRABBER_SIZE = '0.5rem';
export const VERTICAL_RESIZER_OPTIONS = {
  css: {
    // css for normal state
    background: RESIZER_TRANSPARENT_BACKGROUND,
  },
  hoverCss: {
    // css for hover state
    backgroundColor: RESIZER_BACKGROUND_COLOR,
    width: RESIZER_HOVER_SIZE,
    left: RESIZER_POSITION_OFFSET,
  },
  // size of hover zone
  grabberSize: GRABBER_SIZE,
};
export const HORIZONTAL_RESIZER_OPTIONS = {
  css: {
    // css for normal state
    background: RESIZER_TRANSPARENT_BACKGROUND,
  },
  hoverCss: {
    // css for hover state
    backgroundColor: RESIZER_BACKGROUND_COLOR,
    height: RESIZER_HOVER_SIZE,
    top: RESIZER_POSITION_OFFSET,
  },
  // size of hover zone
  grabberSize: GRABBER_SIZE,
};
export const OPERATION_MENU_VERTICAL_RESIZER_OPTIONS = {
  css: {
    // css for normal state
    background: RESIZER_TRANSPARENT_BACKGROUND,
  },
  hoverCss: {
    // css for hover state
    backgroundColor: RESIZER_TRANSPARENT_BACKGROUND,
    width: RESIZER_HOVER_SIZE,
    cursor: 'pointer',
  },
  // size of hover zone
  grabberSize: GRABBER_SIZE,
};
export const PREVIEW_COLLAPSE_PANE_SELECTOR =
  '.SplitPane.horizontal.non-operations-menu-collapse-pane > .Pane.horizontal.non-operations-menu-collapse-pane:nth-child(3)';
export const EVENT_COLLAPSE_PANE_SELECTOR =
  '.SplitPane.vertical.event-collapse-pane > .Pane.vertical.event-collapse-pane:nth-child(3)';
export const DRAGGING_TRANSITION_STYLE = `transition: flex-grow ${COLLAPSE_TRANSITION_TIMEOUT}ms, min-width ${COLLAPSE_TRANSITION_TIMEOUT}ms`;
export const COLLAPSE_TRANSITION_STYLE = `transition: flex-basis ${COLLAPSE_TRANSITION_TIMEOUT}ms, flex-grow ${COLLAPSE_TRANSITION_TIMEOUT}ms, min-width ${COLLAPSE_TRANSITION_TIMEOUT}ms`;
export const RESIZER_BETWEEN_PREVIEW_AND_CODE_SELECTOR =
  '.SplitPane.horizontal.non-operations-menu-collapse-pane > :nth-child(2) > :first-child';
export const RESIZER_BETWEEN_PREVIEW_AND_CODE_DEFAULT_HEIGHT = '0.5rem';
export const RESIZER_BETWEEN_PREVIEW_AND_CODE_DRAG_HEIGHT = '100rem';
export const RESIZER_CONTAINER_BETWEEN_OPERATIONS_MENU_AND_NON_OPERATIONS_SELECTOR =
  '.SplitPane.vertical.top-level-collapse-pane > :nth-child(2)';
export const RESIZER_CONTAINER_BETWEEN_PREVIEW_AND_CODE_SELECTOR =
  '.SplitPane.horizontal.non-operations-menu-collapse-pane > :nth-child(2)';
